import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
//import DatePicker from 'components/base/DatePicker';
import { FormEvent, useState } from 'react';
import { FloatingLabel, Form, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';
// import { useSlideEditorContext } from 'providers/SlideEditorProvider';
import {
  SAVE_PITCHDECK_SETTINGS,
  SET_SLIDE_EDITOR_STATE
} from 'reducers/SlideEditorReducer';
//import { Slide } from 'data/slides';
import usePhoenixForm from 'hooks/usePhoenixForm';
import interceptor from 'services/interceptor';
import { PitchDeckStatus } from 'data/pitchdeckstatus';
import { PitchDeck } from 'data/pitchdecks';
import { useSlideEditorContext } from 'providers/SlideEditorProvider';
//import pitchDeckService from 'services/pitchdeck';

const SlideEditorSettingsModal = () => {
  const {
    pitchDeckId,
    statusId,
    trackingEnabled,
    openSettingsModal,
    slideEditorDispatch
  } = useSlideEditorContext();

  const [pitchDeckStatusList, setPitchDeckStatusList] = useState<
    PitchDeckStatus[]
  >([]);

  const { formData, setFormData, onChange } = usePhoenixForm<PitchDeck>({
    pitchDeckId: pitchDeckId,
    statusId: statusId,
    trackingEnabled: trackingEnabled
  });

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    slideEditorDispatch({
      type: SAVE_PITCHDECK_SETTINGS,
      payload: formData
    });
    handleClose();
  };

  const handleClose = () => {
    slideEditorDispatch({
      type: SET_SLIDE_EDITOR_STATE,
      payload: {
        openSettingsModal: false
      }
    });
  };

  useEffect(() => {
    interceptor.apiWithAuth
      .get('/pitchdeckstatus/get-all')
      .then(response => {
        setPitchDeckStatusList(response.data);
      })
      .catch(error => {
        console.error(error);
      });
  }, []);

  useEffect(() => {
    setFormData({
      ...formData,
      pitchDeckId: pitchDeckId,
      statusId: statusId,
      trackingEnabled: trackingEnabled
    });
  }, [pitchDeckId, statusId, trackingEnabled]);

  return (
    <Modal show={openSettingsModal} onHide={handleClose}>
      <Form onSubmit={handleSubmit}>
        <Modal.Header className="px-card border-0">
          <div className="w-100 d-flex justify-content-between align-items-start">
            <div>
              <h5 className="mb-0 lh-sm text-1000">Settings</h5>
            </div>
            <Button className="p-1 fs-10 text-900" onClick={handleClose}>
              CLOSE
            </Button>
          </div>
        </Modal.Header>
        <Modal.Body className="p-card py-0">
          <FloatingLabel
            controlId="event-title"
            label="Pitch Deck ID"
            className="mb-3"
          >
            <input
              className="form-control"
              onChange={onChange}
              name="pitchDeckId"
              type="text"
              placeholder="ID"
              value={pitchDeckId}
              readOnly
            />
          </FloatingLabel>
          <FloatingLabel controlId="eventLabel" label="Status" className="mb-5">
            <Form.Select
              name="statusId"
              value={formData.statusId}
              onChange={event => {
                setFormData({
                  ...formData,
                  statusId: event.target.value
                });
              }}
            >
              {pitchDeckStatusList.map((pitchDeskStatus, index) => (
                <option key={index} value={pitchDeskStatus.statusId}>
                  {pitchDeskStatus.label}
                </option>
              ))}
            </Form.Select>
          </FloatingLabel>
          <Form.Check>
            <Form.Check.Input
              onChange={event => {
                setFormData({
                  ...formData,
                  trackingEnabled: event.target.checked
                });
              }}
              name="trackingEnabled"
              type="checkbox"
              id="enable-tracking"
              checked={formData.trackingEnabled}
            />
            <Form.Check.Label htmlFor="enable-tracking">
              Enable tracking
            </Form.Check.Label>
          </Form.Check>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between align-items-center border-0">
          <Link
            to="/apps/project-management/project-board-view"
            className="me-3 fs-9 text-900"
          >
            Open projects page
            <FontAwesomeIcon icon={faAngleRight} className="ms-1 fs-10" />
          </Link>
          <Button variant="primary" type="submit" className="px-4">
            Save
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default SlideEditorSettingsModal;
